export default __webpack_public_path__ + "static/blob14-8fd1e9e427db70dd8eaa130f23109d0a.svg";